import DQCPLayout from "../components/DocumentsQRCodePage/DQCPLayout";

const DocumentsQRCodePage = () => {
  return <DQCPLayout />;
};

export default DocumentsQRCodePage;
